// Regra de negócio dos lançamentos mensais (Rampa de lançamentos e Saída de linha):
// os números de um mês SÓ podem ser preenchidos DEPOIS do fechamento do mês, que acontece por volta
// do dia 10 do mês seguinte (ex.: outubro só é preenchido a partir de ~10/novembro).
// Meses passados continuam liberados (preenchimento retroativo). Funções puras, sem dependências.

/** Dia do mês seguinte em que o fechamento costuma estar pronto. Ajuste aqui se o fechamento mudar. */
export const DIA_FECHAMENTO = 10;

/** Primeiro dia do mês (YYYY-MM-01) de uma data. */
export function chaveMes(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
}

/** Data em que o mês `refMonth` (YYYY-MM-01) passa a poder ser preenchido: dia 10 do mês seguinte. */
export function dataLiberacao(refMonth: string): Date {
  const d = new Date(refMonth + 'T00:00:00');
  return new Date(d.getFullYear(), d.getMonth() + 1, DIA_FECHAMENTO);
}

/** O mês já fechou e pode ser preenchido? (a partir do dia 10 do mês seguinte, 00h) */
export function mesLiberado(refMonth: string, hoje: Date = new Date()): boolean {
  return hoje.getTime() >= dataLiberacao(refMonth).getTime();
}

/** Texto curto da data de liberação, ex.: "10/11/2026". */
export function textoLiberacao(refMonth: string): string {
  return dataLiberacao(refMonth).toLocaleDateString('pt-BR');
}

/**
 * Último mês já liberado para preenchimento (YYYY-MM-01).
 * Ex.: hoje 16/10 → set/26; hoje 05/11 → set/26 (outubro ainda não fechou); hoje 10/11 → out/26.
 */
export function ultimoMesLiberado(hoje: Date = new Date()): string {
  const recuo = hoje.getDate() >= DIA_FECHAMENTO ? 1 : 2;
  return chaveMes(new Date(hoje.getFullYear(), hoje.getMonth() - recuo, 1));
}
